import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { CommonService } from '../../../../app/_services/common.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { MobileDetectionService } from '../../../../app/shared/services/mobile-detection.service';
import { OrdersService } from '../../../../app/shared/services/orders/orders.service';
import { ITableModel } from '../../../../app/shared/components/table/model/tableModel';
import { Helpers } from '../../../../app/helpers';
import { ConfirmationPopupComponent } from '../../../../app/shared/components/confirmation-popup/confirmation-popup.component';
import { PrintReportComponent } from '../../../shared/components/print-report/print-report.component';

@Component({
  selector: 'app-purchase-bills-form',
  templateUrl: './purchase-bills-form.component.html',
  styleUrls: ['./purchase-bills-form.component.scss']
})
// added by priya - 31/03/2025
export class PurchaseBillsFormComponent implements OnInit {

  data: any = {};
  CompanyId: any;
  TenantId: any;
  isInternational: any;
  SelectedCompanyGSTCode: any;
  userId: any;
  isMobileView: boolean = false;
  isFormSubmit: boolean = false;
  isChargeFormSubmit: boolean = false;
  dataToSave: any = {};
  selectedId: any;
  BillNo: any;
  StatusName: any;
  newDropdownVisible: boolean = false;
  invoiceData: any = {};
  IsWithoutLR = 0
  showPayment: boolean = false;
  showJournalEntry: boolean = false;
  showAudit: boolean = false;
  showMailHistory: boolean = false;
  BillPaymentSummaryData: any = [];
  JVSummaryData: any = [];
  AuditData: any = [];
  mailHistoryList: any = {};
  dropdownActionVisible: boolean = false
  dropdownPrintVisible: boolean = false
  BalanceAdvanceAmount: any = 0;
  BalanceTDS: any = 0;
  SelectedLRNo: any;
  AdvancePaymentDetailList: any = [];
  @ViewChild("VendorCreditModal") VendorCreditModal: TemplateRef<any>;
  modalRef: NgbModalRef | null = null;
  @ViewChild("ExpensePopup") ExpensePopup: TemplateRef<any>;
  expenseModal: NgbModalRef | null = null;
  fieldData: any = {}
  TaxApplicableFlag: boolean = false;
  GstMasterWithComponent: any = []
  BillAmountWithTax: any = 0;
  TotalAdvanceLeft: any = 0;
  TotalTDSLeft: any = 0;
  NetPayableBillAmount: any = 0;
  BalanceDue: any = 0;
  TDSRates: any = 0;
  NetTotal: any = 0;
  CalcData: any = {}
  Expensebytrip: any = []
  BillsType: string = ''
  isDebit: boolean = false
  IsEditedTableValue: boolean = false;
  static that: PurchaseBillsFormComponent;
  CopyAndCreateNewDisable: boolean = false; // Added by priya - 06/05/2026 - cn(PRIYA-MAY26-001)

  Vendor: any = {
    lable: '',
    formControlName: 'Vendor',
    dataField: 'Vendor',
    isValueBind: true,
    isRequired: true,
    isSearchByApi: true,
    placeholder: "Select Transporter",
  };
  BillDate: any = {
    lable: 'Bill Date',
    formControlName: 'BillDate',
    dataField: 'BillDate',
    isRequired: true,
    type: "text",
    placeholder: 'Select Bill Date'
  };
  PaymentTerms: any = {
    lable: 'Payment terms',
    formControlName: 'PaymentTerms',
    dataField: 'PaymentTerms',
    isRequired: true,
    placeholder: "Enter Payment terms",
    isReadOnly: false,
    type: "number"
  };
  DueDate: any = {
    lable: 'Bill Due Date',
    formControlName: 'DueDate',
    dataField: 'DueDate',
    isRequired: true,
    type: "text",
    placeholder: 'Select Bill Due Date'
  };
  ReferenceNo: any = {
    lable: 'Reference No',
    formControlName: 'ReferenceNo',
    dataField: 'ReferenceNo',
    isRequired: false,
    type: "text",
    placeholder: 'Select Reference No'
  };
  ReferenceDate: any = {
    lable: 'Reference Date',
    formControlName: 'ReferenceDate',
    dataField: 'ReferenceDate',
    isRequired: false,
    type: "text",
    placeholder: 'Select Reference Date'
  };
  ChargeType: any = {
    lable: 'Type',
    formControlName: 'ChargeType',
    dataField: 'ChargeType',
    placeholder: "Enter ChargeType",
    isValueBind: true,
    isReadOnly: false,
  };
  Remarks: any = {
    lable: "Bill Remark",
    formControlName: "Remark",
    dataField: "Remark",
    isRequired: false,
    type: "textarea",
    placeholder: "Enter Bill Remark",
  };
  PaymentTermsRemark: any = {
    lable: "Terms & Conditions",
    formControlName: "PaymentTermsRemark",
    dataField: "PaymentTermsRemark",
    isRequired: false,
    type: "textarea",
    placeholder: "Enter Terms & Conditions",
  };
  BillNumber: any = {
    lable: 'Bill No',
    formControlName: 'BillNumber',
    dataField: 'BillNumber',
    isValueBind: true,
    isRequired: false,
    isSearchByApi: true,
    placeholder: "Select Bill No",
  };

  // Table Fields
  LRNo: any = {
    lable: 'LR No',
    formControlName: 'LRNo',
    dataField: 'LRNo',
    isValueBind: true,
    // isRequired: false,
    isSearchByApi: true,
    placeholder: "LR No",
  };
  IssueNo: any = {
    lable: 'Issue No',
    formControlName: 'IssueId',
    dataField: 'IssueId',
    isValueBind: true,
    isRequired: false,
    isSearchByApi: true,
    placeholder: "Issue No",
  };
  VehicleNo: any = {
    lable: 'Vehicle No',
    formControlName: 'VehicleNo',
    dataField: 'VehicleNo',
    isValueBind: true,
    // isRequired: false,
    isSearchByApi: true,
    placeholder: "Vehicle No",
  };
  Tyre: any = {
    lable: 'Tyre',
    formControlName: 'Tyre',
    dataField: 'Tyre',
    isValueBind: true,
    // isRequired: false,
    isSearchByApi: true,
    placeholder: "Tyre",
  };
  Charge: any = {
    lable: 'Charge',
    formControlName: 'Charge',
    dataField: 'Charge',
    isValueBind: true,
    isRequired: true,
    isSearchByApi: true,
    placeholder: "Charge",
  };
  EANCode: any = {
    lable: 'EAN Code',
    formControlName: 'EANCode',
    dataField: 'EANCode',
    isRequired: false,
    type: "text",
    placeholder: 'EAN Code'
  };
  Odometer: any = {
    lable: 'Odometer',
    formControlName: 'Odometer',
    dataField: 'Odometer',
    isRequired: false,
    type: "number",
    placeholder: 'Odometer'
  };
  HSN: any = {
    lable: 'HSN',
    formControlName: 'HSN',
    dataField: 'HSN',
    isRequired: false,
    type: "text",
    maxLength: 8, // Added by priya - 20/02/2026 - cn(PRIYA-FEB26-004)
    maxInputLength: 8, // Added by priya - 20/02/2026 - cn(PRIYA-FEB26-004)
    placeholder: 'HSN'
  };
  Tax: any = {
    lable: 'Tax',
    formControlName: 'Tax',
    dataField: 'Tax',
    placeholder: "Tax",
    isValueBind: true,
    // isReadOnly: false,
  };
  Tds: any = {
    lable: 'TDS',
    formControlName: 'Tds',
    dataField: 'Tds',
    placeholder: "Tds",
    isValueBind: true,
    isReadOnly: false,
  };
  Unit: any = {
    lable: 'Unit',
    formControlName: 'Unit',
    dataField: 'Unit',
    placeholder: "Unit",
    isReadOnly: false,
    isRequired: true
  };
  Quantity: any = {
    lable: 'Qty',
    formControlName: 'Quantity',
    dataField: 'Quantity',
    isRequired: true,
    type: "number",
    placeholder: 'Quantity'
  };
  Rate: any = {
    lable: 'Rate',
    formControlName: 'Rate',
    dataField: 'Rate',
    isRequired: true,
    type: "number",
    placeholder: 'Rate'
  };
  Discount: any = {
    lable: 'Discount',
    formControlName: 'Discount',
    dataField: 'Discount',
    isRequired: false,
    type: "number",
    placeholder: 'Discount'
  };
  Amount: any = {
    lable: 'Amount',
    formControlName: 'Amount',
    dataField: 'Amount',
    isRequired: false,
    type: "number",
    placeholder: 'Amount'
  };

  // Advance Payment vendor credit fields
  PaidAmount: any = {
    lable: '',
    formControlName: 'PaidAmount',
    dataField: 'PaidAmount',
    isRequired: false,
    isReadOnly: false,
    type: "number",
    placeholder: 'Paid Amount'
  };
  TDSAmount: any = {
    lable: '',
    formControlName: 'TDSAmount',
    dataField: 'TDSAmount',
    isRequired: false,
    isReadOnly: false,
    type: "number",
    placeholder: 'TDS Amount'
  };
  TotalAppliedAdvance: any = {
    lable: '',
    formControlName: 'TotalAppliedAdvance',
    dataField: 'TotalAppliedAdvance',
    isRequired: false,
    isReadOnly: true,
    type: "number",
    placeholder: 'Total Applied Advance'
  };
  TotalAppliedTDS: any = {
    lable: '',
    formControlName: 'TotalAppliedTDS',
    dataField: 'TotalAppliedTDS',
    isRequired: false,
    isReadOnly: true,
    type: "number",
    placeholder: 'Total Applied TDS'
  };
  AppliedAdvance: any = {
    lable: '',
    formControlName: 'AppliedAdvance',
    dataField: 'AppliedAdvance',
    isRequired: false,
    isReadOnly: true,
    type: "number",
    placeholder: 'Applied Advance'
  };
  AppliedTDS: any = {
    lable: '',
    formControlName: 'AppliedTDS',
    dataField: 'AppliedTDS',
    isRequired: false,
    isReadOnly: true,
    type: "number",
    placeholder: 'Applied TDS'
  };
  BalanceBillAmount: any = {
    lable: '',
    formControlName: 'BalanceBillAmount',
    dataField: 'BalanceBillAmount',
    isRequired: false,
    isReadOnly: true,
    type: "number",
    placeholder: 'Balance Bill Amount'
  };
  BalanceTDSAmount: any = {
    lable: '',
    formControlName: 'BalanceTDSAmount',
    dataField: 'BalanceTDSAmount',
    isRequired: false,
    isReadOnly: true,
    type: "number",
    placeholder: 'Balance TDS Amount'
  };

  // added by yash 28-05-2026
  isNotesPanelOpen: boolean = false;
  notesTransactionType: string = 'Purchase Bills';
  notesTransactionId: any = null;
  // end by yash 28-05-2026

  @ViewChild(PrintReportComponent) PrintReportChild: PrintReportComponent;


  constructor(
    private orderservice: OrdersService,
    private _appService: appService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private router: Router,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private mobileDetectionService: MobileDetectionService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) { 
    PurchaseBillsFormComponent.that = this;
  }

  ngOnInit() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.isInternational = JSON.parse(localStorage.getItem("SalesFlag"));
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.selectedId = this.route.snapshot.paramMap.get('id');
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    this.getTransactionType();
    this.getTax();
    this.getTds();
    this.getUnits();
    this.LoadTaxApplicable();
    this.GstMasterWithComponentList();
    this.GetGstList();
    this.fieldData.Quantity = 0;
    this.fieldData.Rate = 0;
    this.fieldData.Discount = 0;
    this.fieldData.Amount = 0;
    this.data.BillDate = new Date();
    this.isDebit = this.orderservice.getBillType();
    if (this.isDebit == true) {
      this.BillsType = 'Debit Note'
    } else {
      this.BillsType = 'Purchase Bills'
    }
    if (this.selectedId !== 'undefined' && this.selectedId !== 'null') {
      this.GetBillById();
    } else {
      this.data.ChargeType = 'Charge';
      this.showColumns(this.data.ChargeType)
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize = (): void => {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  BillDetailsTable: ITableModel = {
    emptyDataMSg: "Bill not added yet. Please add bill.",
    columnDetails: [
      { columnName: "LR No", dataFieldName: "THCName", divType: "", },
      { columnName: "Vehicle No", dataFieldName: "VehicleNo", divType: "", },
      { columnName: "Tyre", dataFieldName: "TyreNo", divType: "", },
      { columnName: "Odometer", dataFieldName: "Odometer", divType: "", },
      { columnName: "EAN Code", dataFieldName: "EANCode", divType: "", },
      { columnName: "Charges", dataFieldName: "ChargeName", divType: "", },
      { columnName: "HSN", dataFieldName: "HSNNo", divType: "", },
      { columnName: "Tax", dataFieldName: "GSTName", divType: "" },
      { columnName: "Unit", dataFieldName: "BasedOn", divType: "", },
      { columnName: "TDS", dataFieldName: "TDSName", divType: "", },
      { columnName: "Qty", dataFieldName: "Quantity", divType: "", alignType: "right", },
      { columnName: "Rate", dataFieldName: "Rate", divType: "", alignType: "right", },
      { columnName: "Discount", dataFieldName: "Discount", divType: "", alignType: "right", },
      { columnName: "Amount", dataFieldName: "Amount", divType: "", alignType: "right", },
      { columnName: "Actions", dataFieldName: '', divType: 'TyreAssignaction', alignType: 'right', width: '10%' },
    ],
    data: [],
    footerData: [
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'Sub Total', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'CGST', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'SGST', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'IGST', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'Less Tds', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'Cess', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'Round Off', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'Net Amount', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'Payments Made', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'Advance Applied', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'Less: Advance TDS', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
      { THCName: '', VehicleNo: '', TyreNo: '', Odometer: '', EANCode: '', ChargeName: '', HSNNo: '', GSTName: 'Balance Due', BasedOn: '', TDSName: "", Quantity: "", Rate: "", Discount: "", Amount: 0.00 },
    ],
    isColumnNameShow: true,
    isShowFooterData: true,
  };

  ExpenseTable: ITableModel = {
    emptyDataMSg: "No Data Found.",
    columnDetails: [
      { columnName: "Booking No", dataFieldName: "FCNumber", divType: "", },
      { columnName: "Charge", dataFieldName: "Charge", divType: "", },
      { columnName: "Product Weight", dataFieldName: "ProductWeight", divType: "", },
      { columnName: "Product Qty", dataFieldName: "ProductQuantity", divType: "", },
      { columnName: "Vehicle Type", dataFieldName: "VehicleType", divType: "", },
      { columnName: "Qty", dataFieldName: "qty", divType: "", },
      { columnName: "Rate", dataFieldName: "Rate", divType: "", alignType: "right", },
      { columnName: "Amount", dataFieldName: "Amount", divType: "", alignType: "right", },
      // { columnName: "Actions", dataFieldName: '', divType: 'TyreAssignaction', alignType: 'right', width: '10%' },
    ],
    data: [],
    footerData: [
      // Added by priya - 20/02/2026 - total for amount - cn(PRIYA-FEB26-004)
      { FCNumber: '', Charge: '', ProductWeight: '', ProductQuantity: '', VehicleType: '', qty: '', Rate: 'Total', Amount: 0.00 },
    ],
    isColumnNameShow: true,
    isShowFooterData: true,
  };

  GSTMasterList: any = [];
  GetGstList() {
    this._appService
      .GetById("Bills", "GetGstList", this.CompanyId)
      .subscribe((Response) => {
        this.GSTMasterList = Response;
      });
  }
  GetBillById() {
    this._appService.GetById("Bills", "GetBillsById", this.selectedId).subscribe(response => {
      this.BillNo = response.BillNo;
      this.StatusName = response.StatusName;
      this.data = response;

      this.isDebit = response.isDebit;
      if (this.isDebit == true) {
        this.BillsType = 'Debit Note';
      } else {
        this.BillsType = 'Purchase Bills';
      }

      this.data.TDSRates = response.TDSAmount;
      if (this.data.VendorName != null) {
        this.data.TranspoterId = response.VendorId;
        this.GetBalancedAdvance(this.data.VendorId);
        this.bill_GetVendorTotalBillAmount(this.data.VendorId);
      } else if (this.data.DriverName != null) {
        this.data.TranspoterId = response.DriverId;
        this.GetBalancedAdvance(this.data.DriverId);
        this.bill_GetVendorTotalBillAmount(this.data.DriverId);
        
      } else {
        this.data.TranspoterId = response.Vendor;
        this.GetBalancedAdvance(this.data.TranspoterId);
        this.bill_GetVendorTotalBillAmount(this.data.TranspoterId);
      }

      this.showColumns(this.data.ChargeType)
      this.setDropdownData(this.Vendor, this.data.VendorId, this.data.VendorName)
      // Added by priya - 23/02/2026 - cn(PRIYA-FEB26-004)
      this.DecideInterIntra(this.data.GSTNo);
      if (this.data.TDSPreference == 'Deducted') {
        this.fieldData.Tds = this.data.TDS;
        this.fieldData.TDS = this.data.TDS;
        let name = this.Tds.dropdownList.find(item => item.value === this.fieldData.Tds);
        this.fieldData.TdsName = name.name
      } else {
        let tdsByDefault = this.Tds.dropdownList.find(item => item.name === 'Not Applicable');
        this.fieldData.Tds = tdsByDefault.value;
        this.fieldData.TDS = tdsByDefault.value;
        this.fieldData.TdsName = tdsByDefault.name;
      }
      // End by priya
      this.BillDetailsTable.data = [];
      let Count = 1;
      this.BillDetailsTable.data = response.BillsDetails.map(element => {
        return {
          THCName: element.THCName,
          THC: element.THC,
          ChargeName: element.ChargeName,
          Charge: element.Charge,
          ChargeId: element.Charge,
          HSNNo: element.HSNNo,
          GstMasterName: (() => {
            if (element.GstMaster == null) return "NA";
            const gst = this.GSTMasterList.find(x => x.Id == element.GstMaster);
            return gst ? gst.Label : "NA";
          })(),
          GSTName: (() => {
            if (element.GstMaster == null) return "NA";
            const gst = this.GSTMasterList.find(x => x.Id == element.GstMaster);
            return gst ? gst.Label : "NA";
          })(),
          GstMasterId: element.GstMaster,
          GstMaster: element.GstMaster,
          BasedOn: element.BasedOn,
          Quantity: element.Quantity,
          Rate: element.Rate,
          Discount: element.Discount,
          Amount: element.Amount,
          BillDetailId: element.BillDetailId,
          TranspoterId: this.data.VendorId,
          ChargeAccount: element.ChargeName,
          Id: Count++,  // Make sure Count is defined or incremented
          VehicleId: element.VehicleId,
          TyreId: element.TyreId,
          VehicleNo: element.VehicleNo,
          TyreNo: element.TyreNo,
          Odometer: element.Odometer,
          VehicleDispatchDate: element.VehicleDispatchDate,
          TDS: element.TDS,
          TDSAmount: element.TDSAmount,
          TDSName: element.TDSName,
          IssueId: element.IssueId,
          IssueNo: element.IssueNo,
          CessAmount: element.CessAmount
        };
      });

      setTimeout(() => {
        this.updateFooterAmounts();
      }, 500);
    },
      (err) => {
        this.toastr.error("Error While Getting Edit data", err);
      }
    );
  }

  setDropdownData(field: any, value: any, name: any) {
    field.dropdownList = [{ value, name }];
    this.data[field.dataField] = value;
  }

  getChangedValue(value, data) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (data.dataField == 'ChargeType') {
      // Added by priya - 23/02/2026 - cn(PRIYA-FEB26-004)
      if (this.BillDetailsTable.data.length > 0){
        return new Promise((resolve) => {
          const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
          dialogRef.componentInstance.details = {
            message: 'Are you sure? All Charges / Account you added below will be deleted.',
            title: 'Confirmation',
          }
          dialogRef.componentInstance.close.subscribe((res: any) => {
            if (res) {
              this.data.ChargeType = value;
              this.showColumns(value);
              this.IsWithoutLR = value;
              this.BillDetailsTable.data = [];
            }
            dialogRef.close();
          });
        })
      } else {
        this.data.ChargeType = value;
        this.showColumns(value);
        this.IsWithoutLR = value;
      }
      // End by priya
    } else if (data.dataField == 'Vendor') {
      this.data[data.dataField] = value.value;
      this.data.VendorId = value.value;
      this.data.Address = value.Address;
      this.data.City = value.City;
      this.data.State = value.State;
      this.data.Country = value.Country;
      this.data.PostalCode = value.PostalCode;
      this.data.PaymentTerms = value.PaymentTerms;
      this.data.Type = value.Type;
      this.data.TransporterId = value.TransporterId;
      this.data.TaxPreference = value.TaxPreference;
      this.data.ExemptionReasons = value.TaxExemptionsReason;
      this.data.TDSPreference = value.TDSPreference;
      this.data.GSTNo = value.GSTNo;
      this.data.MSME = value.MSME;
      this.data.TDS = value.TDS;
      this.data.IsReverseChargeApplicable = value.IsReverseChargeApplicable;
      this.data.Phone = value.Phone;
      this.data.Email = value.Email;
      this.data.TaxApplicable = value.IsTaxable;
      this.data.TranspoterId = value.value;

      if (this.data.ChargeObj == undefined) {
        this.data.ChargeObj = {};
        this.data.ChargeObj.Transpoter = value.name;
        this.data.ChargeObj.TranspoterId = value.value;
      } else {
        this.data.ChargeObj.Transpoter = value.name;
        this.data.ChargeObj.TranspoterId = value.value;
      }
      // Added by priya - 20/02/2026 - cn(PRIYA-FEB26-004)
      if (this.data.TDSPreference == 'Deducted'){
        this.fieldData.Tds = this.data.TDS;
        this.fieldData.TDS = this.data.TDS;
        let name = this.Tds.dropdownList.find(item => item.value === this.fieldData.Tds);
        this.fieldData.TdsName = name.name
      } else {
        let tdsByDefault = this.Tds.dropdownList.find(item => item.name === 'Not Applicable');
        this.fieldData.Tds = tdsByDefault.value;
        this.fieldData.TDS = tdsByDefault.value;
        this.fieldData.TdsName = tdsByDefault.name;
      }
      // End by priya
      this.GetBalancedAdvance(value.value);
      this.DecideInterIntra(this.data.GSTNo);
      this.bill_GetVendorTotalBillAmount(value.value);
      this.GetAdvancePaymentDetailById(value.value);
      this.GetDueDate();
      if (this.data.ChargeType !== 'Account' && this.data.ChargeType !== 'RepairsAndMaintenance'){
        if (value.TaxPreference == "Yes") {
          if (value.GSTNo != null && value.GSTNo != undefined && value.GSTNo != "") {
            this.data.isGSTNo = true;
            this.isDisabled = false;
            this.Tax.isReadOnly = false;
          } else {
            this.data.isGSTNo = false;
            this.isDisabled = true;
            this.Tax.isReadOnly = false;
            this.toastr.error("Kindly enter GST No. in Network Master to enable Save button !", "Error");
          }
        } else {
          this.isDisabled = false;
          this.Tax.isReadOnly = true;
        }
      } else {
        this.isDisabled = false;
        this.Tax.isReadOnly = false;
      }
    } else if (data.dataField == 'BillDate') { // Added by priya - 20/02/2026 - cn(PRIYA-FEB26-004)
      this.data[data.dataField] = value;
      this.GetDueDate();
    } else if (data.dataField == 'PaymentTerms') { // Added by priya - 20/02/2026 - cn(PRIYA-FEB26-004)
      this.data[data.dataField] = value;
      this.GetDueDate();
    } else {
      this.data[data.dataField] = newValue;
    }
  }

  // Added by priya - 20/02/2026 - cn(PRIYA-FEB26-004)
  GetDueDate(){
    const daysToAdd = Number(this.data.PaymentTerms);
    const baseDate = new Date(this.data.BillDate);
    baseDate.setDate(baseDate.getDate() + daysToAdd);
    this.data.DueDate = new Date(baseDate);
  }

  isDisabled: boolean = false;
  get_IsCompanyDisable(Id) {
    this._appService.GetByOneParam('Sales', 'get_IsCompanyDisable', Id).subscribe(
      (response) => {
        if (response[0].IsActive == false || null) {
          this.isDisabled = true;
          this.toastr.error("Selected Driver is disabled, you are not allowed to generate Bill", 'Error')
        }
        else if (response[0].IsDisable == true) {
          this.isDisabled = true;
          this.toastr.error("Selected customer is disabled, you are not allowed to generate Bill", 'Error')
        }
        else {
          this.isDisabled = false
        }
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "Error")
      }
    )
  }

  DecideInterIntra(state) {
    this._appService
      .GetInterOrIntra("Bills", "GetInterOrIntra", state, this.CompanyId)
      .subscribe(
        (response) => {
          this.data.isIntra = response;
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  // Added by priya - 20/02/2026 - cn(PRIYA-FEB26-004)
  GetGstIfApplicable(){
    this._appService.GetByFourId("Bills", "GetGSTIfApplicable", this.data.isIntra, this.fieldData.Charge, this.data.VendorId, this.CompanyId).subscribe(
      (response) => {
        if (response.length > 0) {
          if (response[0] != 0) {
            this.fieldData.GSTMasterId = response[0].Id;
            this.fieldData.Tax = response[0].Id;
            this.fieldData.TaxName = response[0].TaxDisplayName;
            this.fieldData.GstMaster = response[0].TaxDisplayName;
          }
        }
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  bill_GetVendorTotalBillAmount(vendorId) {
    this._appService.GetByTwoId("Bills", "bill_GetVendorTotalBillAmount", vendorId, this.CompanyId).subscribe((response) => {
      var resArray: any = [];
      resArray = response;

      this.data.TotalBillAmount = resArray.length > 0 ? resArray[0].TotalBilLAmount : 0;
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });
  }

  getFieldChangedValue(value, field) {
    // Added by priya - 23/02/2026 - cn(PRIYA-FEB26-004)
    if (!value) {
      this.fieldData[field.dataField] = null;
      return;
    }
    // End by priya
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (field.dataField == 'LRNo') {
      this.fieldData[field.dataField] = value.value;
      this.fieldData.LRName = value.name;
      this.SelectedLRNo = value.value;
      // Added by priya - 23/02/2026 - cn(PRIYA-FEB26-004)
      this.data.PaidWeight = value.PaidWeight;
      this.data.ShortageQuantity = value.ShortageQuantity
      this.data.TotalQuantity = value.TotalQuantity
      if (this.data.ChargeType == "Non Operational" || this.data.ChargeType == "Account") {
        this.fieldData.Quantity = 0;
      } else {
        this.fieldData.Quantity = this.data.TotalQuantity;
      }
      // End by priya
    } else if (field.dataField == 'VehicleNo') {
      this.fieldData[field.dataField] = value.value;
      this.fieldData.VehicleName = value.name;
    } else if (field.dataField == 'Unit') {
      this.fieldData[field.dataField] = value;
      this.fieldData.BasedOn = value;
      if (this.data.ChargeType == "Non Operational" || this.data.ChargeType == "Account") {
        this.fieldData.Quantity = 0;
      } else {
        if (value == "Weight") {
          this.fieldData.Quantity = parseFloat(this.data.PaidWeight).toFixed(2);
        } else if (value == "Package") {
          this.fieldData.Quantity = parseFloat(this.data.TotalQuantity).toFixed(2);
        } else if (value == "Vehicle") {
          this.fieldData.Quantity = 1;
        } else if (value == "Shortage") {
          this.fieldData.Quantity = parseFloat(this.data.ShortageQuantity).toFixed(2);
        } else {
          this.fieldData.Quantity = 1;
        }
      }
      this.calculateAmount();
    } else if (field.dataField == 'Tyre') {
      this.fieldData[field.dataField] = value.value;
      this.fieldData.TyreName = value.name
    } else if (field.dataField == 'Charge') {
      this.fieldData[field.dataField] = value.value;
      this.fieldData.ChargeId = value.value;
      this.fieldData.ChargeName = value.name;
      // Added by priya - 20/02/2026 - cn(PRIYA-FEB26-004)
      this.fieldData.HSN = value.HSNNo;
      this.GetGstIfApplicable();
      // End by priya
    } else if (field.dataField == 'Tax') {
      this.fieldData[field.dataField] = value;
      this.fieldData.GSTMasterId = value;
      let name = this.Tax.dropdownList.find(item => item.value === this.fieldData.Tax);
      this.fieldData.TaxName = name.name
      this.fieldData.GstMaster = name.name;
      
    } else if (field.dataField == 'Tds') {
      this.fieldData[field.dataField] = newValue;
      this.fieldData.TDS = newValue;
      let name = this.Tds.dropdownList.find(item => item.value === this.fieldData.Tds);
      this.fieldData.TdsName = name.name
      this.calculateAmount();
    } else if (field.dataField == 'Quantity') {
      this.fieldData[field.dataField] = value;
      this.calculateAmount();
    } else if (field.dataField == 'Rate') {
      this.fieldData[field.dataField] = value;
      this.calculateAmount();
    } else if (field.dataField == 'Discount') {
      this.fieldData[field.dataField] = value;
      this.calculateAmount();
    } else if (field.dataField == 'IssueId') {
      this.fieldData[field.dataField] = value.value;
      this.fieldData.Odometer = value.OdometerValue;
      this.fieldData.VehicleNo = value.VehicleId;
      this.fieldData.VehicleName = value.VehicleNo;
      this.fieldData.IssueNo = value.name;
      setTimeout(() => {
        this.getVehicleNo(value.VehicleNo);
      }, 500);
    } else {
      this.fieldData[field.dataField] = newValue;
    }
  }

  getPaymentChangedValue(value: any, field: any, Index: number,) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (this.AdvancePaymentDetailList[Index]) {
      if (field.dataField === 'PaidAmount') {
        this.AdvancePaymentDetailList[Index].PaidAmount = value;
        this.ValidateNetAmountForAdvance(this.AdvancePaymentDetailList[Index])
      } else if (field.dataField === 'TDSAmount') {
        this.AdvancePaymentDetailList[Index].TDSAmount = value;
        this.ValidateNetTDSForAdvance(this.AdvancePaymentDetailList[Index])
      } else {
        this.AdvancePaymentDetailList[Index][field.dataField] = value;
      }
    } else {
      this.CalcData[field.dataField] = newValue
    }
  }

  // Display table columns according to charge type
  showColumns(ChargeType) {
    // Define the original set of columns that should always be available
    const originalColumns = [
      { columnName: "LR No", dataFieldName: "THCName", divType: "" },
      { columnName: "Issue No", dataFieldName: "IssueNo", divType: "" },
      { columnName: "Vehicle No", dataFieldName: "VehicleNo", divType: "" },
      { columnName: "Tyre", dataFieldName: "TyreNo", divType: "" },
      { columnName: "Odometer", dataFieldName: "Odometer", divType: "" },
      { columnName: "EAN Code", dataFieldName: "EANCode", divType: "" },
      { columnName: "Charges", dataFieldName: "ChargeName", divType: "" },
      { columnName: "HSN", dataFieldName: "HSNNo", divType: "" },
      { columnName: "Tax", dataFieldName: "GSTName", divType: "" },
      { columnName: "Unit", dataFieldName: "BasedOn", divType: "" },
      { columnName: "TDS", dataFieldName: "TDSName", divType: "" },
      { columnName: "Qty", dataFieldName: "Quantity", divType: "", alignType: "right" },
      { columnName: "Rate", dataFieldName: "Rate", divType: "", alignType: "right" },
      { columnName: "Discount", dataFieldName: "Discount", divType: "", alignType: "right" },
      { columnName: "Amount", dataFieldName: "Amount", divType: "", alignType: "right" },
      { columnName: "Actions", dataFieldName: "", divType: "TyreAssignaction", alignType: "right", width: "10%" }
    ];

    // Start by resetting the columnDetails to the original set
    this.BillDetailsTable.columnDetails = [...originalColumns];
    let columnsToRemove = [];
    if (ChargeType === 'Charge' || ChargeType === 'Operational') {
      this.LRNo.isRequired = true;
      columnsToRemove = ['Vehicle No', 'Tyre', 'Odometer', 'EAN Code', 'Issue No'];
    } else if (ChargeType === 'Account' || ChargeType === 'Non Operational') {
      columnsToRemove = ['Vehicle No', 'Tyre', 'LR No', 'EAN Code', 'Odometer', 'Issue No'];
    } else if (ChargeType === 'RepairsAndMaintenance' || ChargeType === 'Repair & Maintenance') {
      this.VehicleNo.isRequired = true;
      this.Tyre.isRequired = true;
      columnsToRemove = ['LR No', 'EAN Code', 'Issue No'];
    } 
    // else {
    //   columnsToRemove = ['Vehicle No', 'Tyre', 'LR No', 'Odometer', 'Issue No'];
    // }
    // Remove the columns based on the ChargeType
    this.BillDetailsTable.columnDetails = this.BillDetailsTable.columnDetails.filter(column => !columnsToRemove.includes(column.columnName));
  }

  TransactionType = [
    { value: 'Charge', name: 'Operational' }, // charge
    { value: 'Account', name: 'Non Operational' }, // Accounts
    { value: 'RepairsAndMaintenance', name: 'Repair & Maintenance' },
    // { value: 'Product', name: 'Orders' }, // products
  ]

  BasedOn = [
    { value: 'Weight', name: 'Weight' },
    { value: 'Shipment', name: 'Shipment' },
    { value: 'Vehicle', name: 'Vehicle' },
    { value: 'Package', name: 'Package' },
    { value: 'Day', name: 'Day' },
    { value: 'Unit', name: 'Unit' },
    { value: 'Shortage', name: 'Shortage' },
    { value: 'FuelPrice', name: 'FuelPrice' },
    { value: 'PerKM', name: 'PerKM' },
  ]

  getTransactionType() {
    this.ChargeType.dropdownList = this.TransactionType
  }

  getVendor(value, isScrollDown = false) {
    this.Vendor.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Vendor.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageByTenantByTwoId('Bills', 'GetVendorName', value, pageNo, this.TenantId, 'Bills').subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.Vendor.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Vendor.dropdownList);
        this.Vendor = { ...this.Vendor, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Vendor = { ...this.Vendor, dropdownList: [...dropdownList] });
      this.Vendor.isSearch = false;
    }),
      (error => {
        this.Vendor.isSearch = false;
      })
  }

  getBillNumber(value, isScrollDown = false) {
    this.BillNumber.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.BillNumber.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageCompanyId('Common', 'GetBillNoSelect2', value, pageNo, this.CompanyId).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.BillNumber.dropdownList.length) {
        dropdownList = dropdownList.concat(this.BillNumber.dropdownList);
        this.BillNumber = { ...this.BillNumber, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.BillNumber = { ...this.BillNumber, dropdownList: [...dropdownList] });
      this.BillNumber.isSearch = false;
    }),
      (error => {
        this.BillNumber.isSearch = false;
      })
  }

  getLRNo(value, isScrollDown = false) {
    this.LRNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.LRNo.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPageByTenantWithGetTypeByTwoId('Bills', 'GetThcNo', value, pageNo, this.data.VendorId || this.data.DriverId, this.data.Type, 'GetOpen').subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.LRNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.LRNo.dropdownList);
        this.LRNo = { ...this.LRNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.LRNo = { ...this.LRNo, dropdownList: [...dropdownList] });
      this.LRNo.isSearch = false;
    }),
      (error => {
        this.LRNo.isSearch = false;
      })
  }

  getVehicleNo(value, isScrollDown = false) {
    this.VehicleNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleNo.dropdownList.length / 20) + 1;
    }
    this._appService.GetByThreeId('Bills', 'bill_getVehicleNoList', this.CompanyId, this.data.VendorId || this.data.DriverId, value).subscribe(res => {
      res.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleNo.dropdownList);
        this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] });
      this.VehicleNo.isSearch = false;
    }),
      (error => {
        this.VehicleNo.isSearch = false;
      })
  }

  IssueNoSelect2(value, isScrollDown = false) {
    this.IssueNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.IssueNo.dropdownList.length / 40) + 1;
    }
    this.orderservice.IssueNoSelect2(value).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.IssueNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.IssueNo.dropdownList);
        this.IssueNo = { ...this.IssueNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.IssueNo = { ...this.IssueNo, dropdownList: [...dropdownList] });
      this.IssueNo.isSearch = false;
    }).catch(error => {
      this.IssueNo.isSearch = false;
    })
  }

  getTyre(value, isScrollDown = false) {
    this.Tyre.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Tyre.dropdownList.length / 20) + 1;
    }
    this._appService.GetByThreeId('Bills', 'bill_getTyreNoList', this.CompanyId, this.fieldData.VehicleNo, value).subscribe(res => {
      res.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Tyre.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Tyre.dropdownList);
        this.Tyre = { ...this.Tyre, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Tyre = { ...this.Tyre, dropdownList: [...dropdownList] });
      this.Tyre.isSearch = false;
    }),
      (error => {
        this.Tyre.isSearch = false;
      })
  }

  getCharge(value, isScrollDown = false) {
    console.log(' this.SelectedCompanyGSTCode', this.SelectedCompanyGSTCode)
    this.Charge.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Charge.dropdownList.length / 20) + 1;
    }
    let obj: any = {}
    obj.query = value
    obj.PageNo = pageNo
    obj.ChargeType = this.data.ChargeType
    obj.GSTType = this.data.GSTNo == this.SelectedCompanyGSTCode ? "Intra" : "Inter"
    obj.TransporterId = this.data.VendorId
    obj.THCId = this.SelectedLRNo
    this._appService.Post('Bills', 'GetCharges', obj).subscribe(res => {
      res.Results.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.Charge.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Charge.dropdownList);
        this.Charge = { ...this.Charge, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Charge = { ...this.Charge, dropdownList: [...dropdownList] });
      this.Charge.isSearch = false;
    }),
      (error => {
        this.Charge.isSearch = false;
      })
  }

  getTax() {
    this._appService.GetById("Bills", "GetGstList", this.CompanyId).subscribe((Response) => {
      Response.map(x => {
        x.name = x.Label;
        x.value = x.Id;
      })
      this.Tax.dropdownList = Response;
    });
  }

  getTds() {
    this._appService.GetById("Bills", "GetTDSList", this.CompanyId).subscribe((Response) => {
      Response.map(x => {
        x.name = x.Label;
        x.value = x.Id;
      })
      this.Tds.dropdownList = Response;
    });
  }

  GetBalancedAdvance(Id) {
    this._appService.GetByTwoId("Bills", "GetBalanceAdvancePayment", Id, this.CompanyId).subscribe((Response) => {
      if (Response != null) {
        this.BalanceAdvanceAmount = Response.BalanceAdvanceAmount;
        this.BalanceTDS = Response.BalanceTDS;
      } else {
        this.BalanceAdvanceAmount = 0
        this.BalanceTDS = 0
      }
    },
      (err) => {
        this.BalanceAdvanceAmount = 0
        this.BalanceTDS = 0
        this.toastr.error("Error occured while fetching Balanced Advance Amount", "Error");
      });
  }

  getUnits() {
    this.Unit.dropdownList = this.BasedOn
  }

  // Get rate of gst
  GstMasterWithComponentList() {
    this._appService.Get("Bills", "GstMasterWithComponent").subscribe((Response) => {
      this.GstMasterWithComponent = Response;
    });
  }

  LoadTaxApplicable() {
    this._appService.GetById("Common", "GetSystemSettingByName", "IsTaxApplicable").subscribe((response) => {
      if (response == "1") {
        this.TaxApplicableFlag = true;
      } else {
        this.TaxApplicableFlag = false;
      }
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  // get response for vendor credit popup
  GetAdvancePaymentDetailById(Id) {
    this._appService.GetByTwoId("Bills", "GetAdvancePaymentDetailById", Id, this.CompanyId).subscribe((Response) => {
      if (Response != null) {
        const formattedResponse = Response.map((item: any) => ({
          ...item,
          PaymentDate: item.PaymentDate ? this.datePipe.transform(new Date(item.PaymentDate), 'dd-MMM-yyyy') : null,
        }));
        this.AdvancePaymentDetailList = formattedResponse;
        this.CalculateNetAmountForAdvance();
      }
    },
      (err) => {
        this.toastr.error("Error occured while fetching Advance Payment Detail of the Vendor", "Error");
      });
  }

  GetExpenseByTripId(Id) {
    this._appService.GetByOneParam("Sales", "GetExpensebyCN", Id).subscribe((Response) => {
      if (Response != null) {
        this.ExpenseTable.data = Response;
        // Added by priya - 20/02/2026 - total for amount - cn(PRIYA-FEB26-004)
        this.ExpenseTable.footerData[0].Amount = 0;
        this.ExpenseTable.data.forEach(element => {
          this.ExpenseTable.footerData[0].Amount += element.Amount;
        })
        // End by priya
      }
    },
      (err) => {
        this.toastr.error("Error occured while fetching Advance Payment Detail of the Vendor", "Error");
      });
  }

  onAddEntry() {
    if (!this.data.Vendor) {
      this.toastr.warning("Please Select Transporter", 'Error');
      return;
    }
    // Added by priya - 23/02/2026 - cn(PRIYA-FEB26-004)
    var Flag = this.ValidateChargeData();
    if (Flag == true) {
      this.isChargeFormSubmit = true;
      if (!this.IsEditedTableValue){
        this._appService.GetByTwoId('Sales', 'Checkchargefortrip', this.fieldData.LRNo, this.fieldData.ChargeName).subscribe(
          (response) => {
            let Checkchargefortrip: any = response;
            if (Checkchargefortrip && Object.keys(Checkchargefortrip).length > 0) {
              this.toastr.warning("The Bill for the same THC No and Charge Code already exists");
              return;
            }
            for (let i = 0; i < this.BillDetailsTable.data.length; i++) {
              if (this.BillDetailsTable.data[i].LRName === Checkchargefortrip.TripNo &&
                this.BillDetailsTable.data[i].ChargeName === Checkchargefortrip.ChargeAccount) {
                this.toastr.error("The Bill for the same THC No and Charge Code already exists");
                return;
              }
            }
            var obj: any = {};
            obj.ChargeName = this.fieldData.ChargeName;
            obj.ChargeAccount = this.fieldData.ChargeName;
            obj.Charge = this.fieldData.Charge;
            obj.ChargeId = this.fieldData.Charge;
            obj.HSNNo = this.fieldData.HSN;
            obj.GstMaster = this.fieldData.Tax;
            obj.GstMasterId = this.fieldData.Tax;
            obj.GSTName = this.fieldData.TaxName;
            obj.BasedOn = this.fieldData.Unit;
            obj.Quantity = this.fieldData.Quantity;
            obj.Rate = this.fieldData.Rate;
            obj.Discount = this.fieldData.Discount;
            obj.Amount = parseFloat(this.fieldData.Amount);
            obj.BillDetailId = this.selectedId;
            obj.THCName = this.fieldData.LRName;
            obj.THC = this.fieldData.LRNo;
            obj.VehicleId = this.fieldData.VehicleNo;
            obj.TyreId = this.fieldData.Tyre;
            obj.VehicleNo = this.fieldData.VehicleName;
            obj.TyreNo = this.fieldData.TyreName;
            obj.Odometer = this.fieldData.Odometer;
            obj.TDS = this.fieldData.Tds;
            obj.TDSName = this.fieldData.TdsName;
            obj.EANCode = this.fieldData.EANCode;
            obj.VendorName = this.data.VendorName;
            obj.VendorId = this.data.VendorId;
            obj.TDSAmount = this.fieldData.TDSAmount;
            obj.IssueId = this.fieldData.IssueId;
            obj.IssueNo = this.fieldData.IssueNo;
            this.BillDetailsTable.data.push(obj);

            setTimeout(() => {
              this.updateFooterAmounts();
            }, 500);
            this.fieldData.ChargeName = null;
            this.fieldData.Charge = null;
            this.fieldData.HSN = '';
            this.fieldData.Tax = null;
            this.fieldData.TaxName = '';
            this.fieldData.Unit = null;
            this.fieldData.Quantity = 0;
            this.fieldData.Rate = 0;
            this.fieldData.Discount = 0;
            this.fieldData.Amount = 0;
            this.fieldData.LRName = '';
            this.fieldData.LRNo = null;
            this.fieldData.VehicleNo = null;
            this.fieldData.Tyre = null;
            this.fieldData.VehicleName = '';
            this.fieldData.TyreName = '';
            this.fieldData.Odometer = '';
            this.fieldData.Tds = null;
            this.fieldData.TdsName = '';
            this.fieldData.EANCode = '';
            this.fieldData.TDSAmount = '';
          }
        );
      } else {
        var obj: any = {};
        obj.ChargeName = this.fieldData.ChargeName;
        obj.ChargeAccount = this.fieldData.ChargeName;
        obj.Charge = this.fieldData.Charge;
        obj.ChargeId = this.fieldData.Charge;
        obj.HSNNo = this.fieldData.HSN;
        obj.GstMaster = this.fieldData.Tax;
        obj.GstMasterId = this.fieldData.Tax;
        obj.GSTName = this.fieldData.TaxName;
        obj.BasedOn = this.fieldData.Unit;
        obj.Quantity = this.fieldData.Quantity;
        obj.Rate = this.fieldData.Rate;
        obj.Discount = this.fieldData.Discount;
        obj.Amount = parseFloat(this.fieldData.Amount);
        obj.BillDetailId = this.selectedId;
        obj.THCName = this.fieldData.LRName;
        obj.THC = this.fieldData.LRNo;
        obj.VehicleId = this.fieldData.VehicleNo;
        obj.TyreId = this.fieldData.Tyre;
        obj.VehicleNo = this.fieldData.VehicleName;
        obj.TyreNo = this.fieldData.TyreName;
        obj.Odometer = this.fieldData.Odometer;
        obj.TDS = this.fieldData.Tds;
        obj.TDSName = this.fieldData.TdsName;
        obj.EANCode = this.fieldData.EANCode;
        obj.VendorName = this.data.VendorName;
        obj.VendorId = this.data.VendorId;
        obj.TDSAmount = this.fieldData.TDSAmount;
        obj.IssueId = this.fieldData.IssueId;
        obj.IssueNo = this.fieldData.IssueNo;
        this.BillDetailsTable.data.push(obj);
  
        setTimeout(() => {
          this.updateFooterAmounts();
        }, 500);
        this.fieldData.ChargeName = null;
        this.fieldData.Charge = null;
        this.fieldData.HSN = '';
        this.fieldData.Tax = null;
        this.fieldData.TaxName = '';
        this.fieldData.Unit = null;
        this.fieldData.Quantity = 0;
        this.fieldData.Rate = 0;
        this.fieldData.Discount = 0;
        this.fieldData.Amount = 0;
        this.fieldData.LRName = '';
        this.fieldData.LRNo = null;
        this.fieldData.VehicleNo = null;
        this.fieldData.Tyre = null;
        this.fieldData.VehicleName = '';
        this.fieldData.TyreName = '';
        this.fieldData.Odometer = '';
        this.fieldData.Tds = null;
        this.fieldData.TdsName = '';
        this.fieldData.EANCode = '';
        this.fieldData.TDSAmount = '';
      }
      this.isChargeFormSubmit = false;
    }
  }

  tableDetail_Edit(data, index) {
    var obj: any = {};
    obj.ChargeName = data.ChargeName
    obj.HSN = data.HSNNo
    obj.Tax = data.GstMaster
    obj.TaxName = data.GSTName,
      obj.Unit = data.BasedOn,
      obj.Quantity = data.Quantity,
      obj.Rate = data.Rate,
      obj.Discount = data.Discount,
      obj.Amount = data.Amount,
      obj.LRName = data.THCName,
      obj.LRNo = data.THC,
      obj.VehicleNo = data.VehicleId,
      obj.Tyre = data.TyreId,
      obj.VehicleName = data.VehicleNo,
      obj.TyreName = data.TyreNo,
      obj.Odometer = data.Odometer,
      obj.Tds = data.TDS,
      obj.TdsName = data.TDSName,
      obj.EANCode = data.EANCode

    this.fieldData.Unit = data.BasedOn
    this.fieldData.Tax = data.GstMaster
    this.fieldData.TaxName = data.GSTName
    this.fieldData.LRNo = data.THC
    this.fieldData.LRName = data.THCName
    this.fieldData.VehicleNo = data.VehicleId
    this.fieldData.VehicleName = data.VehicleNo
    this.fieldData.Tyre = data.TyreId
    this.fieldData.TyreName = data.TyreNo
    this.fieldData.Tds = data.TDS
    this.fieldData.TdsName = data.TDSName
    this.fieldData.Charge = data.Charge
    this.fieldData.ChargeName = data.ChargeName
    this.fieldData.HSN = data.HSNNo
    this.fieldData.Rate = data.Rate
    this.fieldData.Odometer = data.Odometer
    this.fieldData.EANCode = data.EANCode
    this.fieldData.Quantity = data.Quantity
    this.fieldData.Discount = data.Discount
    this.fieldData.Amount = data.Amount
    this.fieldData.TDSAmount = data.TDSAmount
    this.IsEditedTableValue = true;
    if (data.Charge != null || data.ChargeName != null) {
      this.setDropdownData(this.Charge, data.Charge, data.ChargeName);
    }
    if (data.THC != null || data.THCName != null) {
      this.setDropdownData(this.LRNo, data.THC, data.THCName);
    }
    if (data.VehicleId != null || data.VehicleNo != null) {
      this.setDropdownData(this.VehicleNo, data.VehicleId, data.VehicleNo);
    }
    if (data.TyreId != null || data.TyreNo != null) {
      this.setDropdownData(this.Tyre, data.TyreId, data.TyreNo)
    }
    this.tableDetail_RemoveDataCalculate(data, index);
  }

  // for edit table fields
  tableDetail_Remove(data, index) {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this entry?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          this.tableDetail_RemoveDataCalculate(data, index);
        }
        dialogRef.close();
      });
    })
  }

  // removes table row as well as calculation
  tableDetail_RemoveDataCalculate(data, index) {
    this.BillDetailsTable.data.splice(index, 1);
    setTimeout(() => {
      this.updateFooterAmounts();
    }, 500);
  }

  // calculates amount according to tds rate for fields
  calculateAmount() {
    if (this.fieldData.Quantity == null){
      this.fieldData.Quantity = 0;
    }
    this.fieldData.Amount = this.fieldData.Rate * this.fieldData.Quantity - this.fieldData.Discount || 0;
    if (this.fieldData.Tds !== null || this.fieldData.Tds !== ''){
      var TDSRateIn = this.Tds.dropdownList.find((x) => x.value == this.fieldData.Tds).RateIn;
      // this.fieldData.TDSAmount = parseFloat(((this.fieldData.Amount * TDSRateIn) / 100).toFixed(2));
      this.fieldData.TDSAmount = Math.ceil((this.fieldData.Amount * TDSRateIn) / 100);
      this.fieldData.Amount = parseFloat(this.fieldData.Amount.toFixed(2));
    }
  }

  updateFooterAmounts() {
    this.BillDetailsTable.footerData[0].Amount = 0;  // Sub Total
    this.BillDetailsTable.footerData[1].Amount = 0;  // CGST
    this.BillDetailsTable.footerData[2].Amount = 0;  // SGST
    this.BillDetailsTable.footerData[3].Amount = 0;  // IGST
    this.BillDetailsTable.footerData[4].Amount = 0;  // less tds
    this.BillDetailsTable.footerData[5].Amount = 0;  // cess
    this.BillDetailsTable.footerData[6].Amount = 0;  // Round Off
    this.BillDetailsTable.footerData[7].Amount = 0;  // Net Amount 
    this.BillDetailsTable.footerData[8].Amount = 0;  // payment made 
    this.BillDetailsTable.footerData[9].Amount = 0;  // advance applied
    this.BillDetailsTable.footerData[10].Amount = 0;  // less advance tds
    this.BillDetailsTable.footerData[11].Amount = 0;  // Balance due

    let TDSMain = 0;

    var CGST = this.GstMasterWithComponent.find((x) => x.Id == this.fieldData.Tax && x.TaxComponent == "CGST");
    var SGST = this.GstMasterWithComponent.find((x) => x.Id == this.fieldData.Tax && x.TaxComponent == "SGST");
    var IGST = this.GstMasterWithComponent.find((x) => x.Id == this.fieldData.Tax && x.TaxComponent == "IGST");

    this.BillDetailsTable.data.forEach(element => {
      this.BillDetailsTable.footerData[0].Amount += element.Amount;
      this.BillDetailsTable.footerData[5].Amount += element.CessAmount ? element.CessAmount : 0;

      CGST = this.GstMasterWithComponent.find((x) => x.Id == element.GstMaster && x.TaxComponent == "CGST");
      SGST = this.GstMasterWithComponent.find((x) => x.Id == element.GstMaster && x.TaxComponent == "SGST");
      IGST = this.GstMasterWithComponent.find((x) => x.Id == element.GstMaster && x.TaxComponent == "IGST");

      if (CGST != undefined || CGST != null) {
        let CGSTPer = CGST.TaxRates;
        let CGSTVal = element.Amount * (CGSTPer / 100);
        CGSTVal = element.CGSTAmount = parseFloat(CGSTVal.toFixed(2));
        this.BillDetailsTable.footerData[1].Amount = this.BillDetailsTable.footerData[1].Amount + CGSTVal;
        this.BillDetailsTable.footerData[1].Amount = parseFloat(this.BillDetailsTable.footerData[1].Amount.toFixed(2));
      }

      if (SGST != undefined || SGST != null) {
        let SGSTPer = SGST.TaxRates;
        let SGSTVal = element.Amount * (SGSTPer / 100);
        SGSTVal = element.SGSTAmount = parseFloat(SGSTVal.toFixed(2));
        this.BillDetailsTable.footerData[2].Amount = this.BillDetailsTable.footerData[2].Amount + SGSTVal;
        this.BillDetailsTable.footerData[2].Amount = parseFloat(this.BillDetailsTable.footerData[2].Amount.toFixed(2));
      }

      if (IGST != undefined || IGST != null) {
        let IGSTPer = IGST.TaxRates;
        let IGSTVal = element.Amount * (IGSTPer / 100);
        IGSTVal = element.IGSTAmount = parseFloat(IGSTVal.toFixed(2));
        this.BillDetailsTable.footerData[3].Amount = this.BillDetailsTable.footerData[3].Amount + IGSTVal;
        this.BillDetailsTable.footerData[3].Amount = parseFloat(this.BillDetailsTable.footerData[3].Amount.toFixed(2));
      }

      if (this.TaxApplicableFlag == true) {
        if (this.data.IsReverseChargeApplicable == true) {
          this.BillDetailsTable.footerData[7].Amount = this.BillDetailsTable.footerData[0].Amount;
          this.NetTotal = this.BillDetailsTable.footerData[0].Amount;
        } else {
          this.BillDetailsTable.footerData[7].Amount =
            this.BillDetailsTable.footerData[0].Amount + this.BillDetailsTable.footerData[1].Amount + this.BillDetailsTable.footerData[2].Amount + this.BillDetailsTable.footerData[3].Amount + this.BillDetailsTable.footerData[5].Amount;
          this.NetTotal = this.BillDetailsTable.footerData[0].Amount + this.BillDetailsTable.footerData[1].Amount + this.BillDetailsTable.footerData[2].Amount + this.BillDetailsTable.footerData[3].Amount + this.BillDetailsTable.footerData[5].Amount;
        }
      } else {
        this.BillDetailsTable.footerData[7].Amount = this.BillDetailsTable.footerData[0].Amount;
        this.NetTotal = this.BillDetailsTable.footerData[0].Amount;
        this.BillDetailsTable.footerData[1].Amount = 0;
        this.BillDetailsTable.footerData[2].Amount = 0;
        this.BillDetailsTable.footerData[3].Amount = 0;
        this.BillDetailsTable.footerData[5].Amount = 0;
      }
      this.BillDetailsTable.footerData[7].Amount = parseFloat(this.BillDetailsTable.footerData[7].Amount.toFixed(2));
      this.NetTotal = parseFloat(this.BillDetailsTable.footerData[7].Amount.toFixed(2));

      TDSMain = TDSMain + element.TDSAmount;
      // this.data.TDSRates = TDSMain;
    });
    this.data.AppliedAdvanceTDS =
      this.data.AppliedAdvanceTDS == undefined
        ? 0
        : this.data.AppliedAdvanceTDS;
    TDSMain -= this.data.AppliedAdvanceTDS;
    this.data.TDSRates = parseFloat(TDSMain.toFixed(2));
    this.BillDetailsTable.footerData[4].Amount = this.data.TDSRates;
    this.BillDetailsTable.footerData[6].Amount = parseFloat((Math.round(this.BillDetailsTable.footerData[7].Amount) - this.NetTotal).toFixed(2));
    this.BillDetailsTable.footerData[7].Amount = Math.round(this.BillDetailsTable.footerData[7].Amount);
    this.NetTotal = Math.round(this.BillDetailsTable.footerData[7].Amount);
    this.TDSChange()
  }

  // amount changes according to tds
  TDSChange() {
    this.BillDetailsTable.footerData[10].Amount = this.data.AppliedAdvanceTDS == undefined
      ? 0 : this.data.AppliedAdvanceTDS;
    this.BillDetailsTable.footerData[7].Amount = this.BillDetailsTable.footerData[7].Amount - this.data.TDSRates;
    this.BillDetailsTable.footerData[7].Amount = parseFloat(this.BillDetailsTable.footerData[7].Amount.toFixed(2));
    this.BillDetailsTable.footerData[7].Amount = Math.round(this.BillDetailsTable.footerData[7].Amount);
    let NetTotal = parseFloat(this.BillDetailsTable.footerData[7].Amount.toFixed(2));
    this.NetTotal = Math.round(this.BillDetailsTable.footerData[7].Amount);
    this.CalculateNetAmountForAdvance();
  }

  CalculateNetAmountForAdvance() {
    this.BillAmountWithTax = 0;
    this.TotalAdvanceLeft = 0;
    this.TotalTDSLeft = 0;
    this.CalcData.TotalAppliedAdvance = 0;
    this.CalcData.TotalAppliedTDS = 0;
    this.CalcData.AppliedAdvance = 0;
    this.CalcData.AppliedTDS = 0;

    this.BillDetailsTable.footerData[9].Amount = this.data.AppliedAdvance == undefined ? 0 : this.data.AppliedAdvance;
    this.BillDetailsTable.footerData[10].Amount = this.data.AppliedAdvanceTDS == undefined ? 0 : this.data.AppliedAdvanceTDS;

    this.AdvancePaymentDetailList.forEach((element) => {
      this.TotalAdvanceLeft = this.TotalAdvanceLeft + element.BalanceAdvance;
      this.TotalTDSLeft = this.TotalTDSLeft + element.BalanceTDS;
      this.CalcData.TotalAppliedAdvance = this.CalcData.TotalAppliedAdvance + Number(element.PaidAmount);
      this.CalcData.TotalAppliedTDS = this.CalcData.TotalAppliedTDS + Number(element.TDSAmount);
    });

    this.TotalAdvanceLeft = parseFloat(this.TotalAdvanceLeft.toFixed(2));
    this.TotalTDSLeft = parseFloat(this.TotalTDSLeft.toFixed(2));
    this.CalcData.TotalAppliedAdvance = parseFloat(this.CalcData.TotalAppliedAdvance.toFixed(2));
    this.CalcData.TotalAppliedTDS = parseFloat(this.CalcData.TotalAppliedTDS.toFixed(2));
    this.BillAmountWithTax = this.BillDetailsTable.footerData[0].Amount + this.BillDetailsTable.footerData[1].Amount + this.BillDetailsTable.footerData[2].Amount + this.BillDetailsTable.footerData[3].Amount + this.BillDetailsTable.footerData[5].Amount;
    this.BillAmountWithTax = parseFloat(this.BillAmountWithTax.toFixed(2));
    this.CalcData.AppliedAdvance = this.CalcData.AppliedAdvance + this.CalcData.TotalAppliedAdvance;
    this.CalcData.AppliedTDS = this.CalcData.AppliedTDS + this.CalcData.TotalAppliedTDS;

    this.BillDetailsTable.footerData[9].Amount = this.BillDetailsTable.footerData[9].Amount + this.CalcData.TotalAppliedAdvance;
    this.BillDetailsTable.footerData[10].Amount = this.BillDetailsTable.footerData[10].Amount + this.CalcData.AppliedTDS;
    this.BillDetailsTable.footerData[8].Amount = this.data.PaymentAgainstBill == undefined ? 0 : this.data.PaymentAgainstBill;
    this.BillDetailsTable.footerData[11].Amount =
      this.BillDetailsTable.footerData[7].Amount -
      this.BillDetailsTable.footerData[9].Amount -
      this.BillDetailsTable.footerData[8].Amount -
      this.BillDetailsTable.footerData[10].Amount;
    this.BillDetailsTable.footerData[11].Amount = parseFloat(this.BillDetailsTable.footerData[11].Amount.toFixed(2));
    this.GetNetAdvanceBalanceAmount()
  }

  onSave(){
    this.closeModal();
    this.updateFooterAmounts();
    // this.CalculateNetAmountForAdvance();
    // let TDSMain = 0;
    // this.BillDetailsTable.data.forEach(element => {
    //   TDSMain = TDSMain + element.TDSAmount;
    // })
    // this.data.AppliedAdvanceTDS =
    //   this.data.AppliedAdvanceTDS == undefined
    //     ? 0
    //     : this.data.AppliedAdvanceTDS;
    // TDSMain -= this.data.AppliedAdvanceTDS;
    // this.data.TDSRates = parseFloat(TDSMain.toFixed(2));
    // let TDSRates = Math.round(this.data.TDSRates);
    // this.BillDetailsTable.footerData[4].Amount = TDSRates;
  }

  // calculates advance balance amount in vendor credit popup
  GetNetAdvanceBalanceAmount() {
    this.NetPayableBillAmount = 0;
    this.BalanceDue = 0;
    this.CalcData.BalanceBillAmount = 0;
    this.CalcData.BalanceTDSAmount = 0;
    this.data.PaymentAgainstBill = this.data.PaymentAgainstBill == undefined ? 0 : this.data.PaymentAgainstBill;
    this.CalcData.AppliedAdvance = this.CalcData.AppliedAdvance == undefined ? 0 : this.CalcData.TotalAppliedAdvance;
    this.CalcData.AppliedTDS = this.CalcData.AppliedTDS == undefined ? 0 : this.CalcData.AppliedTDS;
    this.data.AppliedAdvance = this.data.AppliedAdvance == undefined ? 0 : this.data.AppliedAdvance;
    this.data.AppliedAdvanceTDS = this.data.AppliedAdvanceTDS == undefined ? 0 : this.data.AppliedAdvanceTDS;
    // this.CalcData.BalanceBillAmount = this.NetTotal - this.CalcData.AppliedAdvance - this.data.AppliedAdvance - this.data.PaymentAgainstBill - this.CalcData.AppliedTDS;
    this.CalcData.BalanceBillAmount = this.NetTotal - this.CalcData.AppliedAdvance - this.data.AppliedAdvance - this.data.PaymentAgainstBill - this.data.AppliedAdvanceTDS;
    this.CalcData.BalanceBillAmount = parseFloat(this.CalcData.BalanceBillAmount.toFixed(2));
    this.CalcData.BalanceTDSAmount = this.data.TDSRates - this.CalcData.AppliedTDS;
    this.CalcData.BalanceTDSAmount = parseFloat(this.CalcData.BalanceTDSAmount.toFixed(2));
    this.NetPayableBillAmount = this.CalcData.BalanceBillAmount;
    this.NetPayableBillAmount = parseFloat(this.NetPayableBillAmount.toFixed(2));
    this.BalanceDue =
      this.NetTotal -
      this.CalcData.AppliedAdvance -
      this.data.AppliedAdvance -
      this.data.PaymentAgainstBill -
    this.data.AppliedAdvanceTDS;
      // this.CalcData.AppliedTDS;
    this.BalanceDue = parseFloat(this.BalanceDue.toFixed(2));
    this.BillDetailsTable.footerData[11].Amount = this.BalanceDue;
  }

  // Validation for apply advance field in vendor credit popup
  ValidateNetAmountForAdvance(index: number) {
    var ValidateTotalAppliedAdvance: any = 0;
    this.AdvancePaymentDetailList.forEach((element) => {
      console.log(typeof element.PaidAmount);
      ValidateTotalAppliedAdvance = ValidateTotalAppliedAdvance + Number(element.PaidAmount);
    });
    if (ValidateTotalAppliedAdvance <= this.NetTotal) {
      this.CalculateNetAmountForAdvance();
    } else {
      this.toastr.error("Paid Amount is Greater than Net Amount !", "Error");
      this.AdvancePaymentDetailList[index].PaidAmount = 0;
      this.CalculateNetAmountForAdvance();
    }
  }

  // Validation for apply tds field in vendor credit popup
  ValidateNetTDSForAdvance(index: number) {
    var ValidateTotalAppliedTDS = 0;
    this.AdvancePaymentDetailList.forEach((element) => {
      ValidateTotalAppliedTDS = ValidateTotalAppliedTDS + Number(element.TDSAmount);
    });
    if (ValidateTotalAppliedTDS <= this.data.TDSRates) {
      this.CalculateNetAmountForAdvance();
    } else {
      this.toastr.error("Paid TDS is Greater than Total TDS !", "Error");
      this.AdvancePaymentDetailList[index].TDSAmount = 0;
      this.CalculateNetAmountForAdvance();
    }
  }

  ValidateData() {
    var IsValid: boolean = true;
    if (parseFloat(this.data.NetTotal) <= 0) {
      this.toastr.warning("Zero amount bill is not allowed to Post !", "Error");
      IsValid = false;
    }
    if (!this.data.BillDate) {
      this.toastr.warning("Bill Date is required", 'Error');
      IsValid = false;
    }
    if (!this.data.DueDate) {
      this.toastr.warning("Bill Due Date is required", 'Error');
      IsValid = false;
    }
    if (this.data.PaymentTerms === null || this.data.PaymentTerms === undefined || this.data.PaymentTerms === '') {
      this.toastr.warning("Payment Terms is required", 'Error');
      IsValid = false;
    }
    if (!this.data.Vendor) {
      this.toastr.warning("Transporter is required", 'Error');
      IsValid = false;
    }
    return IsValid;
  }

  // Added by priya - 23/02/2026 - validate mandatory fields - cn(PRIYA-FEB26-004)
  ValidateChargeData(){
    var IsValidField: boolean = true;
    if (this.commonService.isStringEmptyOrNull(this.fieldData.Charge)) {
      this.toastr.warning("Charge is required", 'Error');
      IsValidField = false;
    }
    if (this.commonService.isStringEmptyOrNull(this.fieldData.Unit)) {
      this.toastr.warning("Unit is required", 'Error');
      IsValidField = false;
    }
    if (this.commonService.isNotNumberOrNull(this.fieldData.Quantity)) {
      this.toastr.warning("Quantity is required", 'Error');
      IsValidField = false;
    }
    if (this.commonService.isNotNumberOrNull(this.fieldData.Rate)) {
      this.toastr.warning("Rate is required", 'Error');
      IsValidField = false;
    }
    if (this.data.ChargeType == 'Charge' || this.data.ChargeType == 'Operational'){
      if (this.commonService.isStringEmptyOrNull(this.fieldData.LRNo)) {
        this.toastr.warning("LR No is required", 'Error');
        IsValidField = false;
      }
    }
    if (this.data.ChargeType == 'RepairsAndMaintenance' || this.data.ChargeType == 'Repair & Maintenance'){
      if (this.commonService.isStringEmptyOrNull(this.fieldData.VehicleNo)) {
        this.toastr.warning("Vehicle No is required", 'Error');
        IsValidField = false;
      }
      if (this.commonService.isStringEmptyOrNull(this.fieldData.Tyre)) {
        this.toastr.warning("Tyre No is required", 'Error');
        IsValidField = false;
      }
    }
    return IsValidField;
  }

  SaveData() {
    var Flag = this.ValidateData();
    if (Flag == true) {
      this.isFormSubmit = true;

      this.data.VendorGSTNo = this.data.GSTNo;
      this.data.Town = this.data.City;
      this.data.GSTStateCode = this.data.GSTNo;

      this.data.SGSTAmount = this.BillDetailsTable.footerData[2].Amount;
      this.data.CGSTAmount = this.BillDetailsTable.footerData[1].Amount;
      this.data.IGSTAmount = this.BillDetailsTable.footerData[3].Amount;
      this.data.SubTotal = this.BillDetailsTable.footerData[0].Amount;
      this.data.NetTotal = this.BillDetailsTable.footerData[7].Amount;
      this.data.AppliedAdvance = this.BillDetailsTable.footerData[9].Amount;
      this.data.AppliedAdvanceTDS = this.BillDetailsTable.footerData[10].Amount;
      this.data.RoundOfAmount = parseFloat((Math.round(this.BillDetailsTable.footerData[11].Amount) - this.BillDetailsTable.footerData[11].Amount).toFixed(2));
      this.data.TDSAmount = this.data.TDSRates;

      // this.data.PaymentTermsRemark = $("#PaymentTermsRemark").val();
      // this.data.TdsId = $("#TDS").val();
      // this.data.BillRefId = $("#BillNoSelect").val();

      if (this.data.Type == "Transpoter") {
        this.data.Vendor = this.data.Vendor;
        this.data.DriverId = null;
      }
      if (this.data.Type == "Driver") {
        this.data.DriverId = this.data.Vendor;
        this.data.Vendor = null;
      }
      // this.data.FulePumpId = $("#FuelPump").val();

      this.data.TaxApplicable = this.data.TaxPreference;
      this.data.CompanyId = this.CompanyId;
      this.data.SubTotal = this.data.SubTotal;
      this.data.BillDetails = [];
      this.data.BillDetails = this.BillDetailsTable.data;
      if (this.data.IsPaymentRequestBill) {
        this.data.IsPaymentRequest = true;
      } else {
        this.data.IsPaymentRequest = false;
      }

      var BillDetailsConsignmentwiseArray = [];
      for (var k = 0; k < this.BillDetailsTable.data.length; k++) {
        if (BillDetailsConsignmentwiseArray.length == 0) {
          var tempOBJ: any = {};
          tempOBJ.BillsHeaderId = null;
          tempOBJ.THC = this.BillDetailsTable.data[k].THC;
          if (this.data.IsReverseChargeApplicable == true) {
            tempOBJ.TotalAmount =
              this.BillDetailsTable.data[k].Amount - this.BillDetailsTable.data[k].TDSAmount;
          } else {
            tempOBJ.TotalAmount =
              this.BillDetailsTable.data[k].Amount +
              (this.BillDetailsTable.data[k].CGSTAmount == undefined ||
                this.BillDetailsTable.data[k].CGSTAmount == null
                ? 0
                : this.BillDetailsTable.data[k].CGSTAmount) +
              (this.BillDetailsTable.data[k].SGSTAmount == undefined ||
                this.BillDetailsTable.data[k].SGSTAmount == null
                ? 0
                : this.BillDetailsTable.data[k].SGSTAmount) +
              (this.BillDetailsTable.data[k].IGSTAmount == undefined ||
                this.BillDetailsTable.data[k].IGSTAmount == null
                ? 0
                : this.BillDetailsTable.data[k].IGSTAmount) -
              this.BillDetailsTable.data[k].TDSAmount;
          }
          tempOBJ.PaidAmount = this.data.AppliedAdvance;
          // tempOBJ.TotalTDS = (this.BillDetailsTable.data[k].Amount * TDSRateIn) / 100;
          tempOBJ.TotalTDS = this.BillDetailsTable.data[k].TDSAmount;
          tempOBJ.PaidTDS = this.data.AppliedAdvanceTDS;
          BillDetailsConsignmentwiseArray.push(tempOBJ);
        } else {
          if (this.data.IsReverseChargeApplicable == true) {
            BillDetailsConsignmentwiseArray[0].TotalAmount =
              BillDetailsConsignmentwiseArray[0].TotalAmount +
              (this.BillDetailsTable.data[k].Amount - this.BillDetailsTable.data[k].TDSAmount);
          } else {
            BillDetailsConsignmentwiseArray[0].TotalAmount =
              BillDetailsConsignmentwiseArray[0].TotalAmount +
              (this.BillDetailsTable.data[k].Amount +
                (this.BillDetailsTable.data[k].CGSTAmount == undefined ||
                  this.BillDetailsTable.data[k].CGSTAmount == null
                  ? 0
                  : this.BillDetailsTable.data[k].CGSTAmount) +
                (this.BillDetailsTable.data[k].SGSTAmount == undefined ||
                  this.BillDetailsTable.data[k].SGSTAmount == null
                  ? 0
                  : this.BillDetailsTable.data[k].SGSTAmount) +
                (this.BillDetailsTable.data[k].IGSTAmount == undefined ||
                  this.BillDetailsTable.data[k].IGSTAmount == null
                  ? 0
                  : this.BillDetailsTable.data[k].IGSTAmount) -
                this.BillDetailsTable.data[k].TDSAmount);
          }
          // BillDetailsConsignmentwiseArray[0].TotalTDS = BillDetailsConsignmentwiseArray[0].TotalTDS + (this.BillDetailsTable.data[k].Amount * TDSRateIn) / 100;
          BillDetailsConsignmentwiseArray[0].TotalTDS =
            BillDetailsConsignmentwiseArray[0].TotalTDS +
            this.BillDetailsTable.data[k].TDSAmount;
        }
      }
      this.data.BillDetailsConsignmentwise = [];
      this.data.BillDetailsConsignmentwise = BillDetailsConsignmentwiseArray;
      this.data.THC = null;
      this.data.isDebit = this.isDebit;

      if (this.BillDetailsTable.data.length > 0) {
        this._appService.Post("Bills", "SaveBills", this.data).subscribe(
          (response) => {
            this.data.Id = response;
            this.selectedId = response;
            // this.ShowAttachment = true;
            this.SavePaymentDetail();
            setTimeout(() => {
              // this.onBack();
              this.GetBillById();
            }, 500);
            Helpers.setLoading(false);
            this.toastr.success("Bill Details Saved Successfully ", "Bills");
          },
          (err) => {
            // $("#btnSaveForBill").prop("disabled", false);
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
      } else {
        // $("#btnSaveForBill").prop("disabled", false);
        Helpers.setLoading(false);
        this.toastr.error("Please Select any Charge/Account !", "Error");
      }
    }
  }

  SavePaymentDetail() {
    var PaymentData = [];
    this.AdvancePaymentDetailList.forEach((element) => {
      if (!(element.PaidAmount == 0 && element.TDSAmount == 0)) {
        var obj: any = {};
        jQuery.extend(true, {}, obj);
        obj.BillPaymentId = element.Id;
        obj.BillId = this.data.Id;
        obj.PaidAmount = element.PaidAmount;
        obj.TDSAmount = element.TDSAmount;
        obj.Id = element.BillPaymentDetailId;
        PaymentData.push(obj);
      }
    });
    if (PaymentData.length > 0) {
      //   this.SaveBills();
      this._appService
        .Post("BillPayment", "SaveBillPaymentDetails", PaymentData)
        .subscribe(
          (response) => {
            if (response.length > 0) {
              // $("#AdvancePayment").modal("hide");
              this.AdvancePaymentDetailList.forEach((Advancelist) => {
                response.forEach((element) => {
                  if (element.BillPaymentId == Advancelist.Id) {
                    Advancelist.BillPaymentDetailId = element.Id;
                  }
                });
              });
            }
          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "error");
          }
        );
    }
  }

  OnClickBillPaymentReceipt() {
    // this.showPayment = !this.showPayment;
    // if (this.showPayment == true) {
      if (this.data.Id != null && this.data.Id != undefined) {
        this._appService.GetById("Bills", "GetBillPaymentSummary", this.data.Id).subscribe(
          (response) => {
            const formattedResponse = response.map((item: any) => ({
              ...item,
              PaymentDate: item.PaymentDate ? this.datePipe.transform(new Date(item.PaymentDate), 'dd-MMM-yyyy') : null,
            }));
            this.BillPaymentSummaryData = formattedResponse || [];
          },
          (err) => {
            this.toastr.error("An error occured !", "error");
          })
      }
    // }
  }

  OnClickJournalEntry() {
    // this.showJournalEntry = !this.showJournalEntry;
    // if (this.showJournalEntry == true) {
      if (this.data.Id != null && this.data.Id != undefined) {
        Helpers.setLoading(true);
        this._appService.GetById("Sales", "GetJournalEntrySummary", this.data.Id).subscribe(
          (response) => {
            this.JVSummaryData = response;
          },
          (err) => {
            this.toastr.error("An error occured  !", "error");
          });
        Helpers.setLoading(false);
      }
    // }
  }

  OnClickAudit() {
    // this.showAudit = !this.showAudit;
    // if (this.showAudit == true) {
      if (this.data.Id != null && this.data.Id != undefined) {
        Helpers.setLoading(true);
        var pageURL = "Bills";
        this._appService.GetByTwoId("Common", "getAuditTrailData", this.data.Id, pageURL).subscribe((response) => {
          this.AuditData = response || [];
          Helpers.setLoading(false);
        },
          (error) => {
            Helpers.setLoading(false);
            this.toastr.error("An error occured", error);
          });
      }
    // }
  }

  // opens vendor credit popup
  OpenVendorCredit() {
    if (this.data.VendorId) {
      this.modalRef = this.modalService.open(this.VendorCreditModal, { windowClass: 'creditPopup', size: "lg" });
      if (this.modalRef) {
        this.GetAdvancePaymentDetailById(this.data.VendorId)
      }
    } else if (this.data.DriverId) {
      this.modalRef = this.modalService.open(this.VendorCreditModal, { windowClass: 'creditPopup', size: "lg" });
      if (this.modalRef) {
        this.GetAdvancePaymentDetailById(this.data.DriverId)
      }
    } else {
      this.toastr.error("Please Select Transporter");
    }
  }

  closeModal() {
    this.modalRef.close();
  }

  ViewExpense() {
    if (this.fieldData.LRNo) {
      this.expenseModal = this.modalService.open(this.ExpensePopup, { windowClass: 'ExpensePopup', size: "lg" });
      if (this.expenseModal) {
        this.GetExpenseByTripId(this.fieldData.LRNo)
      }
    } else {
      this.toastr.error("Please Select LR No");
    }
  }

  closeExpense() {
    this.expenseModal.close();
  }

  onActionClick({ row, actionName, index }) {
    if (actionName == "Edit") {
      this.tableDetail_Edit(row, index);
    } else if (actionName.trim() == "Delete") {
      this.tableDetail_Remove(row, index);
    }
  }

  // added by yash 28-05-2026
  openNotesPanel() {
    this.notesTransactionType = 'Purchase Bills';
    this.notesTransactionId = this.selectedId;
    this.isNotesPanelOpen = true;
    this.dropdownActionVisible = false;
  }

  onSelectItemNew(event) {
    if (event.actionName == 'Notes') {
      this.notesTransactionType = 'Purchase Bills';
      this.notesTransactionId = this.selectedId;
      this.isNotesPanelOpen = true;
    }
  }
  // end by yash 28-05-2026

  BackToList() {
    const source = localStorage.getItem('navigationSourceBills');
    localStorage.removeItem('navigationSourceBills');

    if (source  === 'PendingTripForBills') {
      this.router.navigateByUrl(`/pending-purchase-bill`);
    } else {
      this.router.navigateByUrl(`/purchase-bills`);
    }
  }

  toggleActionDropdown() {
    this.dropdownActionVisible = !this.dropdownActionVisible;
  }

  showDropdown() {
    this.dropdownActionVisible = true;
  }

  hideDropdown() {
    this.dropdownActionVisible = false;
  }

  togglePrintDropdown() {
    this.dropdownPrintVisible = !this.dropdownPrintVisible;
  }

  showPrintDropdown() {
    this.dropdownPrintVisible = true;
  }

  hidePrintDropdown() {
    this.dropdownPrintVisible = false;
  }

  newToggleDrop() {
    this.newDropdownVisible = !this.newDropdownVisible;
  }

  AuthorizeBill() {
    Helpers.setLoading(true);
    this._appService
      .GetByThreeId(
        "Common",
        "AuthorizeTransaction",
        3,
        this.data.Id,
        this.CompanyId
      )
      .subscribe(
        (response) => {
          if (response == 8) {
            this.toastr.error("Please Map TDS before posting!");
            return;
          }
          this.toastr.success("Bill Authorized Successfully !", "Success");
          this.GetBillById();
        },
        (err) => {
          this.toastr.error(err ? err._body.replace(/"/g, "") : "An error occured  !", "Error");
        }
      );
    Helpers.setLoading(false);
  }

  PostPurchaseBill() {
    if (this.data.NetTotal != 0) {
      Helpers.setLoading(true);
      this._appService
        .GetByTwoId("Bills", "PostPurchaseBill", this.data.Id, this.CompanyId)
        .subscribe(
          (response) => {
            if (response == 100) {
              this.toastr.error(
                "Please Configure Reverse Tax  in Manage Taxes !",
                "Error"
              );
            }
            else if (response == 11) {
              this.toastr.info("Network is unauthorised", 'error')
              return;
            }
            else if (response == 2) {
              this.toastr.info("Chart of Account not found", 'Info');
              return;
            }
            else {
              this.toastr.success("Bill Posted Successfully !", "Success");
              this.GetBillById();
            }
          },
          (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
      Helpers.setLoading(false);
    } else {
      this.toastr.error("Zero amount bill is not allowed to Post !", "Error");
    }
  }

  DeletePurchaseBill(Id) {
    return new Promise((resolve) => {
      const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
      dialogRef.componentInstance.details = {
        message: 'Are you sure you want to delete this bill?',
        title: 'Confirmation',
      }
      dialogRef.componentInstance.close.subscribe((res: any) => {
        if (res) {
          Helpers.setLoading(true);
          this._appService.Delete("Bills", "DeleteBills", Id).subscribe((response) => {
            Helpers.setLoading(false);
            let resSTR = JSON.stringify(response);
            let resJSON = JSON.parse(resSTR);
            if (resJSON._body == 100) {
              this.toastr.warning(
                "You can't delete Bill because payment is already made. ",
                "warning"
              );
            } else {
              this.SaveDeletedTransactionHistory(Id);
              this.toastr.success(
                "Bills Deleted Successfully ",
                "Success"
              );
            }
          },
            (err) => {
              this.toastr.error(err._body.replace(/"/g, ""), "error");
              Helpers.setLoading(false);
            }
          );
        }
        dialogRef.close();
      });
    })
  }

  SaveDeletedTransactionHistory(Id) {
    var obj: any = {};
    obj.TransactionId = Id;
    obj.TransactionType = "Bills";
    obj.UserId = this.userId;

    this._appService.Post("Common", "SaveDelTransactionHistory", obj).subscribe(
      (response) => { },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  PrintReport(Type: any) {
    if (Type == 'Detail') {
      this.PrintReportChild.CompanyId = this.CompanyId;
      this.PrintReportChild.BillId = this.data.Id;
      this.PrintReportChild.ReportType = 'Bills Detail';
      this.PrintReportChild.PrintInvoice();
    }
  }

  // Added by priya - 06/05/2026 - cn(PRIYA-MAY26-001)
  CopyAndCreateNew(){
    Helpers.setLoading(true);
    this.isFormSubmit = true;
    this.CopyAndCreateNewDisable = true;
    var flag = this.ValidateData();
    if (flag == true) {
      this.data.VendorGSTNo = this.data.GSTNo;
      this.data.Town = this.data.City;
      this.data.GSTStateCode = this.data.GSTNo;
      this.data.SGSTAmount = this.BillDetailsTable.footerData[2].Amount;
      this.data.CGSTAmount = this.BillDetailsTable.footerData[1].Amount;
      this.data.IGSTAmount = this.BillDetailsTable.footerData[3].Amount;
      this.data.SubTotal = this.BillDetailsTable.footerData[0].Amount;
      this.data.NetTotal = this.BillDetailsTable.footerData[7].Amount;
      this.data.AppliedAdvance = this.BillDetailsTable.footerData[9].Amount;
      this.data.AppliedAdvanceTDS = this.BillDetailsTable.footerData[10].Amount;
      this.data.RoundOfAmount = parseFloat((Math.round(this.BillDetailsTable.footerData[11].Amount) - this.BillDetailsTable.footerData[11].Amount).toFixed(2));
      this.data.TDSAmount = this.data.TDSRates;
      this.data.Id = null;
      this.data.Status = null;
      this.data.IsAuthorized = false;
      this.data.IsPosted = false;
      this.data.BillNo = null;
      this.data.BillNumber = null;

      if (this.data.Type == "Transpoter") {
        this.data.Vendor = this.data.Vendor;
        this.data.DriverId = null;
      }
      if (this.data.Type == "Driver") {
        this.data.DriverId = this.data.Vendor;
        this.data.Vendor = null;
      }

      this.data.TaxApplicable = this.data.TaxPreference;
      this.data.CompanyId = this.CompanyId;
      this.data.SubTotal = this.data.SubTotal;
      this.data.BillDetails = [];
      this.data.BillDetails = this.BillDetailsTable.data;
      if (this.data.IsPaymentRequestBill) {
        this.data.IsPaymentRequest = true;
      } else {
        this.data.IsPaymentRequest = false;
      }

      var BillDetailsConsignmentwiseArray = [];
      for (var k = 0; k < this.BillDetailsTable.data.length; k++) {
        if (BillDetailsConsignmentwiseArray.length == 0) {
          var tempOBJ: any = {};
          tempOBJ.BillsHeaderId = null;
          tempOBJ.THC = this.BillDetailsTable.data[k].THC;
          if (this.data.IsReverseChargeApplicable == true) {
            tempOBJ.TotalAmount =
              this.BillDetailsTable.data[k].Amount - this.BillDetailsTable.data[k].TDSAmount;
          } else {
            tempOBJ.TotalAmount =
              this.BillDetailsTable.data[k].Amount +
              (this.BillDetailsTable.data[k].CGSTAmount == undefined ||
                this.BillDetailsTable.data[k].CGSTAmount == null
                ? 0
                : this.BillDetailsTable.data[k].CGSTAmount) +
              (this.BillDetailsTable.data[k].SGSTAmount == undefined ||
                this.BillDetailsTable.data[k].SGSTAmount == null
                ? 0
                : this.BillDetailsTable.data[k].SGSTAmount) +
              (this.BillDetailsTable.data[k].IGSTAmount == undefined ||
                this.BillDetailsTable.data[k].IGSTAmount == null
                ? 0
                : this.BillDetailsTable.data[k].IGSTAmount) -
              this.BillDetailsTable.data[k].TDSAmount;
          }
          tempOBJ.PaidAmount = this.data.AppliedAdvance;
          // tempOBJ.TotalTDS = (this.BillDetailsTable.data[k].Amount * TDSRateIn) / 100;
          tempOBJ.TotalTDS = this.BillDetailsTable.data[k].TDSAmount;
          tempOBJ.PaidTDS = this.data.AppliedAdvanceTDS;
          BillDetailsConsignmentwiseArray.push(tempOBJ);
        } else {
          if (this.data.IsReverseChargeApplicable == true) {
            BillDetailsConsignmentwiseArray[0].TotalAmount =
              BillDetailsConsignmentwiseArray[0].TotalAmount +
              (this.BillDetailsTable.data[k].Amount - this.BillDetailsTable.data[k].TDSAmount);
          } else {
            BillDetailsConsignmentwiseArray[0].TotalAmount =
              BillDetailsConsignmentwiseArray[0].TotalAmount +
              (this.BillDetailsTable.data[k].Amount +
                (this.BillDetailsTable.data[k].CGSTAmount == undefined ||
                  this.BillDetailsTable.data[k].CGSTAmount == null
                  ? 0
                  : this.BillDetailsTable.data[k].CGSTAmount) +
                (this.BillDetailsTable.data[k].SGSTAmount == undefined ||
                  this.BillDetailsTable.data[k].SGSTAmount == null
                  ? 0
                  : this.BillDetailsTable.data[k].SGSTAmount) +
                (this.BillDetailsTable.data[k].IGSTAmount == undefined ||
                  this.BillDetailsTable.data[k].IGSTAmount == null
                  ? 0
                  : this.BillDetailsTable.data[k].IGSTAmount) -
                this.BillDetailsTable.data[k].TDSAmount);
          }
          // BillDetailsConsignmentwiseArray[0].TotalTDS = BillDetailsConsignmentwiseArray[0].TotalTDS + (this.BillDetailsTable.data[k].Amount * TDSRateIn) / 100;
          BillDetailsConsignmentwiseArray[0].TotalTDS =
            BillDetailsConsignmentwiseArray[0].TotalTDS +
            this.BillDetailsTable.data[k].TDSAmount;
        }
      }
      this.data.BillDetailsConsignmentwise = [];
      this.data.BillDetailsConsignmentwise = BillDetailsConsignmentwiseArray;
      this.data.THC = null;
      this.data.isDebit = this.isDebit;

      if (this.BillDetailsTable.data.length > 0) {
        this._appService.Post("Bills", "SaveBills", this.data).subscribe(
          (response) => {
            this.data.Id = response;
            this.selectedId = response;
            this.SavePaymentDetail();
            setTimeout(() => {
              this.GetBillById();
            }, 500);
            Helpers.setLoading(false);
            this.toastr.success("Bill Details Saved Successfully ", "Bills");
          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error(err._body.replace(/"/g, ""), "Error");
          }
        );
        this.CopyAndCreateNewDisable = false;
      } else {
        Helpers.setLoading(false);
        this.toastr.error("Please Select any Charge/Account !", "Error");
      }
    }
  }

}
